export default __webpack_public_path__ + "static/media/boo-add-sqaud1.4f3473a9.png";